import { useState, useEffect, useCallback } from "react";
import { FaUserPlus} from "react-icons/fa";
import SideNave from "../common/sidenav";
import TopNav from "../common/topnav";
import DataTable from "react-data-table-component";
import "../common/style.css";
import { useNavigate } from "react-router-dom";
import { showProjects } from "../http/api";
import Loading from "../loading/loading";

export default function EnrollProjects() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    localStorage.getItem("sb|sidebar-toggle") === "true"
  );
  const [projects, setProjects] = useState([]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    localStorage.setItem("sb|sidebar-toggle", !isSidebarOpen);
  };

  const fetchProjects = useCallback(() => {
    setLoading(true);
    showProjects()
      .then((response) => {
        if (response.status === 200) {
          setProjects(response.data || []);
        }
      })
      .catch((err) => console.error("Error fetching projects:", err))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  // const handleAddCandidate = (projectId) => {
  //   navigate(`/addCandidate/${projectId}`);
  // };

  // const handleUploadCandidate = (projectId) => {
  //   navigate(`/uploadCandidate/${projectId}`);
  // };

  const columns = [
    {
      name: "Project Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Location",
      selector: (row) => row.locations,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <button
            className="btn btn-sm btn-success"
            // onClick={() => handleAddCandidate(row.id)}
            onClick={() => navigate(`/manageCandidates/${row.id}`)}
          >
            <FaUserPlus /> Manage Candidate
          </button>
          {/* <button
            className="btn btn-sm btn-primary"
            onClick={() => handleUploadCandidate(row.id)}
          >
            <FaUpload /> Upload Candidate
          </button> */}
        </div>
      ),
    },
  ];

  return (
    <div className="EnrollProjects">
      {loading && <Loading />}
      <div
        className={`sb-nav-fixed ${isSidebarOpen ? "sb-sidenav-toggled" : ""}`}
      >
        <TopNav toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div id="layoutSidenav">
          <SideNave isSidebarOpen={isSidebarOpen} />
          <div id="layoutSidenav_content">
            <main>
              <div className="container-fluid px-4">
                <h4 className="mt-4">Enroll Candidates into Projects</h4>
                <div className="card mb-4">
                  <div className="card-header">
                    <i className="fas fa-table me-1"></i>
                    Project List
                  </div>
                  <div className="card-body shadow-sm border-0">
                    <DataTable
                      className="data-table"
                      columns={columns}
                      data={projects}
                      pagination
                      highlightOnHover
                    />
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}
